import React from "react";
import img1 from "../../assets/projects/product1.jpg";
import img2 from "../../assets/projects/product2.jpg";
import img3 from "../../assets/projects/product3.jpg";
import img4 from "../../assets/projects/product4.jpg";
import img5 from "../../assets/projects/product5.jpg";
import img6 from "../../assets/projects/product6.jpg";
import img7 from "../../assets/projects/product7.jpg";
import img8 from "../../assets/projects/product8.jpg";
import img9 from "../../assets/projects/product9.jpg";
import img10 from "../../assets/projects/product10.jpg";
import img11 from "../../assets/projects/product11.jpg";
import styles from "./ProjectCard.module.css";
import { getImageUrl } from "../../utils";
import { useNavigate } from "react-router-dom";

export const ProjectCard = ({
  project: { title, imageSrc, description, id },
  group: group,
}) => {
  let image = {
    src: imageSrc,
  };
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <div>
        <img
          src={imageSrc}
          alt={`Image of ${title}`}
          className={styles.image}
          onClick={() => {
            navigate(`/products/${id}`);
          }}
        />
      </div>
      <div
        className={styles.title}
        onClick={() => {
          navigate(`/products/${id}`);
        }}
      >
        {title}
      </div>
      {/* <p
        className={styles.description}
        onClick={() => {
          navigate(`/products/${id}`);
        }}
      >
        {description}
      </p> */}
      {/* <ul className={styles.skills}>
        {skills.map((skill, id) => {
          return (
            <li key={id} className={styles.skill}>
              {skill}
            </li>
          );
        })}
      </ul> */}
      {/* <div className={styles.links}>
        <a href={demo} className={styles.link}>
          Demo
        </a>
        <a href={source} className={styles.link}>
          Source
        </a>
      </div> */}
    </div>
  );
};
